import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { ProgramList } from '../../constants/program-list';
import { AishPreScreenLabels } from './prescreen.label';
import { AishBenefitsReceived } from '../../constants/aish-benefits-received';

const diaName = ProgramList.dia;
const aishName = ProgramList.aish;
const adapName = ProgramList.adap;
const incomeSupportName = ProgramList.incomeSupport;

export const AishMySituationLabels: IntakeLabelCollection = {
  pageIntro: {
    label:
      'Please answer questions on this page carefully. Incorrect answers may result in delays with your application or it may mean your application will be paused and you will have to provide missing information.',
    onBehalfLabel: `Please answer questions on this page carefully. Incorrect answers may result in delays with <<oboName>>'s application or it may mean their application will be paused and you will have to provide missing information.`,
  },
  reapplying: {
    label: `Are you waiting for an outcome on a previous ${diaName.abbreviation} application and wondering if you should reapply now?`,
  },
  hasTrustee: {
    label: 'Do you have a Trustee or someone currently acting under a Power of Attorney?',
    onBehalfLabel: `Does <<oboName>> have a Trustee or someone currently acting under a Power of Attorney?`,
  },
  hasContacts: {
    label: `Would you like to name an individual or organization ${diaName.abbreviation} can contact, or who can contact ${diaName.abbreviation}, about your application?`,
    onBehalfLabel: `Would you like to name an individual or organization ${diaName.abbreviation} can contact, or who can contact ${diaName.abbreviation}, about <<oboName>>'s application?`,
  },
  isInPalliativeCare: {
    label:
      'Are you currently receiving palliative care, or has a medical professional told you that your illness is terminal?',
    onBehalfLabel: `Is <<oboName>> currently receiving palliative care, or has a medical professional told you that their illness is terminal?`,
  },
  isInLongTermSupportiveLiving: {
    label:
      'Are you currently living in, or have been assessed, approved and are awaiting placement in a permanent care facility, continuing care home, or similar setting?',
    onBehalfLabel: `Is <<oboName>> currently living in, or has been assessed, approved, and is awaiting placement in a permanent care facility, nursing home, or similar setting?`,
  },
  hasIncomeSupportBenefits: {
    label: `Are you receiving ${incomeSupportName.fullName} from the Alberta Government?`,
    spousePartnerLabel: `Are you and/or your <<spouseLabel>> receiving ${incomeSupportName.fullName} from the Alberta Government?`,
    onBehalfLabel: `Is <<oboName>> receiving ${incomeSupportName.fullName} from the Alberta Government?`,
    onBehalfSpousePartnerLabel: `Is <<oboName>> and/or their <<spouseLabel>> receiving ${incomeSupportName.fullName} from the Alberta Government?`,
  },
  isEmployed: {
    label: 'Have you ever been employed?',
  },
  maritalStatus: {
    label: 'What is your marital status?',
    onBehalfLabel: `What is <<oboName>>'s marital status?`,
  },
  hasDependentChild: {
    label: 'Do you have dependent child(ren)?',
    onBehalfLabel: `Does <<oboName>> have dependent child(ren)?`,
  },
  receivedDIABenifits: {
    ...AishPreScreenLabels.receivedDIABenifits,
    onBehalfLabel: `Has <<oboName>> received ${aishName.abbreviation} or ${adapName.abbreviation} benefits in the last 24 months?`,
  },
  currentClientReapplying: {
    // label: `Are you a current ${adapName.abbreviation} client who previously received ${aishName.abbreviation} and are reapplying for ${aishName.abbreviation}?`,
    // onBehalfLabel: `Is <<oboName>> a current ${adapName.abbreviation} client who previously received ${aishName.abbreviation} and are reapplying for ${aishName.abbreviation}?`,
    label: `Are you a current ${adapName.abbreviation} client who transitioned from ${aishName.abbreviation} to ${adapName.abbreviation} and want to apply for ${aishName.abbreviation}?`,
    onBehalfLabel: `Is <<oboName>> a current ${adapName.abbreviation} client who transitioned from ${aishName.abbreviation} to ${adapName.abbreviation} and want to apply for ${aishName.abbreviation}?`,
  },
};

//pattern is question_answercode
export const AishMySituationAnswerLabels: IntakeLabelCollection = {
  receivedBenefits_yes_transition: {
    // label: `Yes - My file was transitioned to ${adapName.abbreviation} July 2, 2026`,
    label: `${AishBenefitsReceived.yes_transition?.displayValue}`,
    onBehalfLabel: `Yes - Their file was transitioned to ${adapName.abbreviation} <<adapDate>>`,
  },
  receivedBenefits_yes_stopped: {
    // label: `Yes - I was receiving ${aishName.abbreviation} or ${adapName.abbreviation} within the last 24 months but stopped`,
    label: `${AishBenefitsReceived.yes_stopped?.displayValue}`,
    onBehalfLabel: `Yes - They were receiving ${aishName.abbreviation} or ${adapName.abbreviation} within the last 24 months but stopped`,
  },
  receivedBenefits_no: {
    // label: 'No',
    label: `${AishBenefitsReceived.no?.displayValue}`,
  },
};

export const AishMySituationHelperTexts: IntakeLabelCollection = {
  isInPalliativeCare: {
    label: 'Note: If you select yes, you need to provide a medical document confirming your illness.',
    onBehalfLabel: 'Note: If you select yes, you need to provide a medical document confirming their illness.',
  },
  isInLongTermSupportiveLiving: {
    label:
      'Note: If you select yes, you need to provide a medical document confirming you need continuing care or supportive living.',
    onBehalfLabel:
      'Note: If you select yes, you need to provide a medical document confirming they need continuing care or supportive living.',
  },
};
